import React, { useEffect, useRef } from 'react';
import { Box } from '@mui/material';

const MouseWaveEffect: React.FC<{}> = (props) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const mousePos = useRef({ x: 0, y: 0 });
  const gradientPos = useRef({ x: 0, y: 0 });
  const frameId = useRef<number | undefined>(undefined);

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      if (containerRef.current) {
        const rect = containerRef.current.getBoundingClientRect();
        mousePos.current = {
          x: ((e.clientX - rect.left) / rect.width) * 100,
          y: ((e.clientY - rect.top) / rect.height) * 100,
        };
      }
    };

    const animate = () => {
      // Smooth interpolation
      gradientPos.current = {
        x: gradientPos.current.x + (mousePos.current.x - gradientPos.current.x) * 0.1,
        y: gradientPos.current.y + (mousePos.current.y - gradientPos.current.y) * 0.1,
      };

      if (containerRef.current) {
        containerRef.current.style.background = `
          radial-gradient(
            600px circle at ${gradientPos.current.x}% ${gradientPos.current.y}%,
            rgba(63, 160, 255, 0.15),
            rgba(63, 160, 255, 0.05) 40%,
            rgba(63, 160, 255, 0) 60%
          )
        `;
      }

      frameId.current = requestAnimationFrame(animate);
    };

    window.addEventListener('mousemove', handleMouseMove);
    frameId.current = requestAnimationFrame(animate);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      if (frameId.current) {
        cancelAnimationFrame(frameId.current);
      }
    };
  }, []);

  return (
    <Box
      ref={containerRef}
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        pointerEvents: 'none',
        zIndex: 0,
        transition: 'background 0.05s ease-out',
      }}
    />
  );
};

export default MouseWaveEffect;
